$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});